import { alpha, Button, ButtonProps, SxProps } from "@mui/material";
import { PropsWithChildren } from "react";

export function SelectableButton({
    selected,
    children,
    sx,
    ...buttonProps
}: PropsWithChildren<{ selected: boolean; sx?: SxProps } & ButtonProps>) {
    return (
        <Button
            {...buttonProps}
            sx={[
                theme => ({
                    borderWidth: "1px",
                    flexGrow: 1,
                    borderStyle: "solid",
                    borderColor: selected ? theme.palette.primary.main : theme.palette.divider,
                    backgroundColor: selected ? alpha(theme.palette.primary.light, 0.08) : "transparent",
                    padding: 1,
                    color: theme.palette.text.primary,
                    textTransform: "none",
                    borderRadius: 1,
                }),
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {children}
        </Button>
    );
}
